import { cn } from "@/libs/utils";
import { FC } from "react";

const FieldInput: FC<{
  type: 1 | 2 | 3 | 4 | 5 | 6;
  defaultValue: number;
  valueMultiple: string;
  data: { idFinanceur: number; year: number; month: number; idDevise: number };
  compact?: boolean;
}> = ({ type, defaultValue, valueMultiple, data, compact = false }) => {
  const inputBaseClassName = cn(
    "flex w-full items-center rounded-md border border-input pointer-events-none text-background",
    compact ? "h-7 p-1.5 text-[11px]" : "h-8 p-2 text-xs",
  );
  const styleType1 = cn(
    inputBaseClassName,
    "bg-verdeoblue focus-visible:border-verdeoblue focus-visible:text-verdeoblue",
    defaultValue == 0
      ? "bg-background text-verdeoblue border border-verdeoblue"
      : "focus-visible:text-background"
  );
  const styleType2 = cn(
    inputBaseClassName,
    "bg-verdeogreen focus-visible:border-verdeogreen focus-visible:text-verdeogreen",
    defaultValue == 0
      ? "bg-background text-verdeogreen border border-verdeogreen"
      : "focus-visible:text-background"
  );
  const styleType3 = cn(
    inputBaseClassName,
    "bg-verdeoorange focus-visible:border-verdeoorange focus-visible:text-verdeoorange",
    defaultValue == 0
      ? "bg-background text-verdeoorange border border-verdeoorange"
      : "focus-visible:text-background"
  );

  const styleType4 = cn(
    inputBaseClassName,
    "bg-[#ff0000] focus-visible:border-[#ff0000] focus-visible:text-[#ff0000]",
    defaultValue == 0
      ? "bg-background text-[#ff0000] border border-[#ff0000]"
      : "focus-visible:text-background"
  );

  const styleType5 = cn(
    inputBaseClassName,
    "bg-[#a1560b] focus-visible:border-[#a1560b] focus-visible:text-[#a1560b]",
    defaultValue == 0
      ? "bg-background text-[#a1560b] border border-[#a1560b]"
      : "focus-visible:text-background"
  );

  const styleType6 = cn(
    inputBaseClassName,
    "bg-[#425e1a] focus-visible:border-[#425e1a] focus-visible:text-[#425e1a]",
    defaultValue == 0
      ? "bg-background text-[#425e1a] border border-[#425e1a]"
      : "focus-visible:text-background"
  );
  return (
    <div
      className={cn(
        "relative flex-1",
        compact ? "px-0.5 pt-0.5" : "px-1 pt-1",
      )}
    >
      <div
        className={
          type == 1
            ? styleType1
            : type == 2
            ? styleType2
            : type == 3
            ? styleType3
            : type == 4
            ? styleType4
            : type == 5
            ? styleType5
            : styleType6
        }
      >
        {defaultValue.toLocaleString("fr-FR", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}
      </div>
      {/* {valueMultiple != '' && <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Info size={15} className="text-blue-500 absolute right-0 top-0 bg-background rounded-full"/>
            </TooltipTrigger>
            <TooltipContent>
              {valueMultiple.split('\n').map((line, index) => (
                line.includes("Total") ? <p key={index} className="mt-2"><strong>{line}</strong></p> : <p key={index} className="mb-0">{line}</p>
              ))}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>} */}
    </div>
  );
};

export default FieldInput;
